import type { ExtrajudicialNotification } from '../../../types';
import { diffInDays } from '../../../utils/helpers';
import type { TableData } from '../../base-components/table/TableData';

export const columns = (tab: string) => [
  {
    name: 'ccn',
    show: true,
  },
  {
    name: 'repossessionStartedDate',
    show: true,
  },
  {
    name: 'attemptNumber',
    show: true,
  },
  {
    name: 'createdAt',
    show: tab === 'PENDING_RESULT',
  },
  {
    name: 'sentAt',
    show: true,
  },
  {
    name: 'customerFullName',
    show: true,
  },
  {
    name: 'preConfirmationDate',
    show: tab !== 'PENDING_RESULT',
  },
  {
    name: 'confirmationDate',
    show: tab !== 'PENDING_RESULT',
  },
  {
    name: 'status',
    show: true,
  },
  {
    name: 'denialReason',
    show: tab !== 'PENDING_RESULT',
  },
  {
    name: 'openFor',
    show: tab === 'PENDING_DECISION',
  },
  {
    name: 'decision',
    show: tab === 'OTHER',
  },
  {
    name: 'assignment',
    show: tab !== 'PENDING_RESULT',
  },
];

export const buildEjnTableData = (
  extrajudicialNotification: ExtrajudicialNotification,
): TableData => {
  return {
    key: extrajudicialNotification.id,
    columns: [
      {
        name: 'ccn',
        value: extrajudicialNotification.notification.ccn,
      },
      {
        name: 'repossessionStartedDate',
        value: extrajudicialNotification.notification.repossessionStartedDate,
      },
      {
        name: 'attemptNumber',
        value: extrajudicialNotification.attemptNumber,
      },
      {
        name: 'createdAt',
        value: extrajudicialNotification.createdAt,
      },
      {
        name: 'sentAt',
        value: extrajudicialNotification.sentAt,
      },
      {
        name: 'customerFullName',
        value: extrajudicialNotification.notification.participant.fullName,
      },
      {
        name: 'preConfirmationDate',
        value: extrajudicialNotification.preConfirmationDate,
      },
      {
        name: 'confirmationDate',
        value: extrajudicialNotification.confirmationDate,
      },
      {
        name: 'status',
        value: extrajudicialNotification.status,
      },
      {
        name: 'denialReason',
        value: extrajudicialNotification.denialReason,
      },
      {
        name: 'openFor',
        value: diffInDays(
          new Date(extrajudicialNotification.sentAt),
          new Date(),
        ),
      },
      {
        name: 'decision',
        value: extrajudicialNotification.decision,
      },
      {
        name: 'assignment',
        value: extrajudicialNotification.assignment?.consultantName || null,
      },
    ],
  };
};
